module.exports = __webpack_public_path__ + "img/logoSenalba.9dda2306.png";